// extracted by mini-css-extract-plugin
export var form = "_51-0";